module.exports = __webpack_public_path__ + "img/IMG_0833.10f500b9.png";